<template>
  <div id="card">
    <nav-common></nav-common>
    <div class="card-content">
      <el-tabs type="border-card" @tab-click="handleClick">
          <el-tab-pane label="进度查询">
              <ul class="list">
                  <li v-for="bank of progress">
                      <a :href="bank.link">
                          <span><img :src="'./static/img/' + bank.imagSrc" /></span>
                          <div class="name" v-text="bank.name"></div>
                      </a>
                  </li>
              </ul>
          </el-tab-pane>
          <el-tab-pane label="本级办卡查询">
              <el-table
                  :data="card.data"
                  border
                  style="width: 100%">
                  <el-table-column
                  fixed
                  prop="bank_name"
                  label="办卡渠道"
                  align="center"
                  width="180">
                  </el-table-column>
                  <el-table-column
                  prop="agent_name"
                  label="代理商"
                  align="center"
                  width="180">
                  </el-table-column>
                  <el-table-column
                  prop="status"
                  label="状态"
                  align="center"
                  width="180">
                  </el-table-column>
                  <el-table-column
                  prop="name"
                  label="姓名"
                  align="center"
                  width="180">
                  </el-table-column>
                  <el-table-column
                  prop="phone"
                  label="手机号"
                  align="center"
                  width="200">
                  </el-table-column>
                  <el-table-column
                  prop="created_at"
                  label="申请时间"
                  align="center"
                  width="263">
                  </el-table-column>
              </el-table>
              <el-pagination
                  background
                  layout="prev, pager, next"
                  :page-size="card.per_page"
                  @current-change="getcard"
                  :current-page="card.current_page"
                  :total="card.total">
              </el-pagination>
          </el-tab-pane>
          <el-tab-pane label="二级办卡查询">
              <el-table
                  :data="card.data"
                  border
                  style="width: 100%">
                  <el-table-column
                  fixed
                  prop="bank_name"
                  label="办卡渠道"
                  align="center"
                  width="180">
                  </el-table-column>
                  <el-table-column
                  prop="agent_name"
                  label="代理商"
                  align="center"
                  width="180">
                  </el-table-column>
                  <el-table-column
                  prop="status"
                  label="状态"
                  align="center"
                  width="180">
                  </el-table-column>
                  <el-table-column
                  prop="name"
                  label="姓名"
                  align="center"
                  width="180">
                  </el-table-column>
                  <el-table-column
                  prop="phone"
                  label="手机号"
                  align="center"
                  width="200">
                  </el-table-column>
                  <el-table-column
                  prop="created_at"
                  label="申请时间"
                  align="center"
                  width="263">
                  </el-table-column>
              </el-table>
              <el-pagination
                  background
                  layout="prev, pager, next"
                  :page-size="card.per_page"
                  @current-change="getcard"
                  :current-page="card.current_page"
                  :total="card.total">
              </el-pagination>
          </el-tab-pane>
          <!-- <el-tab-pane label="三级办卡查询">
              <el-table
                  :data="card.data"
                  border
                  style="width: 100%">
                  <el-table-column
                  fixed
                  prop="bank_name"
                  label="办卡渠道"
                  align="center"
                  width="180">
                  </el-table-column>
                  <el-table-column
                  prop="agent_name"
                  label="代理商"
                  align="center"
                  width="180">
                  </el-table-column>
                  <el-table-column
                  prop="status"
                  label="状态"
                  align="center"
                  width="180">
                  </el-table-column>
                  <el-table-column
                  prop="name"
                  label="姓名"
                  align="center"
                  width="180">
                  </el-table-column>
                  <el-table-column
                  prop="phone"
                  label="手机号"
                  align="center"
                  width="200">
                  </el-table-column>
                  <el-table-column
                  prop="created_at"
                  label="申请时间"
                  align="center"
                  width="263">
                  </el-table-column>
              </el-table>
               <el-pagination
                  background
                  layout="prev, pager, next"
                  :page-size="card.per_page"
                  @current-change="getcard"
                  :current-page="card.current_page"
                  :total="card.total">
              </el-pagination>
          </el-tab-pane>
          <el-tab-pane label="四级办卡查询">
              <el-table
                  :data="card.data"
                  border
                  style="width: 100%">
                  <el-table-column
                  fixed
                  prop="bank_name"
                  label="办卡渠道"
                  align="center"
                  width="180">
                  </el-table-column>
                  <el-table-column
                  prop="agent_name"
                  label="代理商"
                  align="center"
                  width="180">
                  </el-table-column>
                  <el-table-column
                  prop="status"
                  label="状态"
                  align="center"
                  width="180">
                  </el-table-column>
                  <el-table-column
                  prop="name"
                  label="姓名"
                  align="center"
                  width="180">
                  </el-table-column>
                  <el-table-column
                  prop="phone"
                  label="手机号"
                  align="center"
                  width="200">
                  </el-table-column>
                  <el-table-column
                  prop="created_at"
                  label="申请时间"
                  align="center"
                  width="263">
                  </el-table-column>
              </el-table>
               <el-pagination
                  background
                  layout="prev, pager, next"
                  :page-size="card.per_page"
                  @current-change="getcard"
                  :current-page="card.current_page"
                  :total="card.total">
              </el-pagination>
          </el-tab-pane>
          <el-tab-pane label="五级办卡查询">
              <el-table
                  :data="card.data"
                  border
                  style="width: 100%">
                  <el-table-column
                  fixed
                  prop="bank_name"
                  label="办卡渠道"
                  align="center"
                  width="180">
                  </el-table-column>
                  <el-table-column
                  prop="agent_name"
                  label="代理商"
                  align="center"
                  width="180">
                  </el-table-column>
                  <el-table-column
                  prop="status"
                  label="状态"
                  align="center"
                  width="180">
                  </el-table-column>
                  <el-table-column
                  prop="name"
                  label="姓名"
                  align="center"
                  width="180">
                  </el-table-column>
                  <el-table-column
                  prop="phone"
                  label="手机号"
                  align="center"
                  width="200">
                  </el-table-column>
                  <el-table-column
                  prop="created_at"
                  label="申请时间"
                  align="center"
                  width="263">
                  </el-table-column>
              </el-table>
               <el-pagination
                  background
                  layout="prev, pager, next"
                  :page-size="card.per_page"
                  @current-change="getcard"
                  :current-page="card.current_page"
                  :total="card.total">
              </el-pagination>
          </el-tab-pane>
          <el-tab-pane label="六级办卡查询">
              <el-table
                  :data="card.data"
                  border
                  style="width: 100%">
                  <el-table-column
                  fixed
                  prop="bank_name"
                  label="办卡渠道"
                  align="center"
                  width="180">
                  </el-table-column>
                  <el-table-column
                  prop="agent_name"
                  label="代理商"
                  align="center"
                  width="180">
                  </el-table-column>
                  <el-table-column
                  prop="status"
                  label="状态"
                  align="center"
                  width="180">
                  </el-table-column>
                  <el-table-column
                  prop="name"
                  label="姓名"
                  align="center"
                  width="180">
                  </el-table-column>
                  <el-table-column
                  prop="phone"
                  label="手机号"
                  align="center"
                  width="200">
                  </el-table-column>
                  <el-table-column
                  prop="created_at"
                  label="申请时间"
                  align="center"
                  width="263">
                  </el-table-column>
              </el-table>
               <el-pagination
                  background
                  layout="prev, pager, next"
                  :page-size="card.per_page"
                  @current-change="getcard"
                  :current-page="card.current_page"
                  :total="card.total">
              </el-pagination>
          </el-tab-pane> -->
      </el-tabs>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import NavCommon from '@/components/navtop/navcommon'

export default {
  name: 'Card',
  data () {
    return {
        progress: [
            {
                name: '平安银行',
                link: 'https://c.pingan.com/apply/newpublic/credit_card_query/index.html#index',
                imagSrc: 'pa.png'
            },
            {
                name: '兴业银行',
                link: 'https://3g.cib.com.cn/app/00282.html',
                imagSrc: 'xy.png'
            },
            {
                name: '广发银行',
                link: 'https://ebanks.cgbchina.com.cn/channelsLink/applyStatusQuery.do',
                imagSrc: 'gf.png'
            },
            {
                name: '中信银行',
                link: 'https://e.bank.ecitic.com/perbank5/pb0212_applyProcessQry.do',
                imagSrc: 'zx.png'
            },
            {
                name: '招商银行',
                link: 'https://ccclub.cmbchina.com/mca/ShowMessage.aspx?msgcode=CM006',
                imagSrc: 'zhaoshang.png'
            },
            {
                name: '上海银行',
                link: 'https://ebanks.bankofshanghai.com/pweb/LogoutCreditApplyProQryPre.do?_locale=zh_CN',
                imagSrc: 'sh.png'
            },
            {
                name: '华夏银行',
                link: 'https://creditcloud.hxb.com.cn/hxypt/CridetCardApplySchedule.do?_locale=zh_CN&LoginType=C',
                imagSrc: 'hx.png'
            },
            {
                name: '中国银行',
                link: 'https://ebsnew.boc.cn/boc15/login.html',
                imagSrc: 'zg.png'
            },
            {
                name: '浦发银行',
                link: 'https://www.spdbccc.com.cn/spdb/cupd/applyProgress.do?method=index',
                imagSrc: 'pf.png'
            },
            {
                name: '渣打银行',
                link: 'https://ccibanking.standardchartered.com.cn/onlinebank/apply.do?pid=81224316-5.hjfWR5RRQkC3OGVs-tYapg.1',
                imagSrc: 'zd.png'
            },
            {
                name: '民生银行',
                link: 'https://kefu.creditcard.cmbc.com.cn/wdxykindex.shtml?age=11#dingWeiAllByHSY',
                imagSrc: 'ms.png'
            },
            {
                name: '渤海银行',
                link: 'https://onlinepay.cupdata.com/weixin/apply.do?action=applyProgressInit&bankNum=0317&userId=ofQfVs0oIwXN-V3-4BSnkZEZNm48',
                imagSrc: 'bohai.png'
            },
            {
                name: '花旗银行',
                link: 'https://www.citibank.com.cn/CNGCB/ICARD/appsta/showNext.do?JFP_TOKEN=4EYJRVIP',
                imagSrc: 'hq.png'
            },
            {
                name: '建设银行',
                link: 'https://creditcard.ccb.com/tran/WCCMainPlatV5?CCB_IBSVersion=V5&SERVLET_NAME=WCCMainPlatV5&TXCODE=EWX311&wParam=QMerSTmogaHKx%2FJD4S7Cw3ezLV1cj%2FA4',
                imagSrc: 'js.png'
            },
            {
                name: '交通银行',
                link: 'https://creditcardapp.bankcomm.com/member/apply/status/preinquiry.html',
                imagSrc: 'jt.jpg'
            },
            {
                name: '光大银行',
                link: 'https://xyk.cebbank.com/home/portal/invalid.htm',
                imagSrc: 'gd.png'
            },
            {
                name: '农业银行',
                link: 'https://eapply.abchina.com/CreditCardApp/CreditcardsInfo/CreditSearch',
                imagSrc: 'ny.png'
            },
            {
                name: '工商银行',
                link: 'https://mybank.icbc.com.cn/icbc/newperbank/perbank3/frame/frame_index.jsp',
                imagSrc: 'gs.png'
            },
            {
                name: '上海农商银行',
                link: 'https://onlinepay.cupdata.com/weixin/apply.do?action=applyProgressInit&bankNum=6501&userId=oSJt4jkS8a5TXl_z9vnb6uD5jGB0',
                imagSrc: 'shanghainongshang.png'
            },
            {
                name: '北京银行',
                link: 'https://card.bankofbeijing.com.cn/OAM_BJ/apply.do',
                imagSrc: 'bj.png'
            },
            {
                name: '广州银行',
                link: 'https://creditcard.gzcb.com.cn/gzcb_web/transactionApply.action',
                imagSrc: 'gz.png'
            }
        ],
        card: {},
        params: '',
    }
  },
  created() {
  },
  methods: {
    handleClick(tab, event) {
        var index = parseInt(tab.index);
        var _this = this;
        switch(index) {
            case 1:
                _this.params = 'self';
                _this.getcard(1);
                break;
            case 2:
                _this.params = 'sub';
                _this.getcard(1);
                break;
            case 3:
                _this.params = 'subsub';
                _this.getcard(1);
                break;
            case 4:
               _this.params = 'fourth';
                _this.getcard(1);
                break;
            case 5:
                _this.params = 'fifth';
                _this.getcard(1);
                break;
            case 6:
                _this.params = 'sixth';
                _this.getcard(1);
                break;
            default:
                return;
        };
    },
    getcard(page) {
        var _this = this;
        _this.$http({
            method: 'get',
            url: _this.$api + '/service/agent/card/' + _this.params + '?page=' + page
        }).then((res) => {
            _this.card = res.data.data;
            _this.card.data.forEach(element => {
            if(element.status == 0) {
                element.status ='已提交';
            } else if (element.status == 1) {
                let cardStatusText = '下卡';  
                if(element.is_active==1 && element.is_first_use==1 && element.active_status==0 && element.first_use_status==0){
                    cardStatusText = '待首刷';
                }
                if(element.is_active==1 && element.is_first_use==1 && element.active_status==1 && element.first_use_status==1){
                    cardStatusText = '已首刷';
                }
                if(element.first_use_reward>0 && element.first_use_status==0){
                    cardStatusText = '下卡/待首刷'
                }
                if(element.first_use_reward>0 && element.first_use_status==1){
                    cardStatusText = '下卡/已首刷'
                }
               element.status = cardStatusText;
            } else if (element.status == 2 || element.status==3) {
                element.status = '无记录/审核未通过';
            }
            });
        })
    }
  },
  components: {
    NavCommon
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="stylus" rel="stylesheet/stylus">
    #card
      .card-content
        position relative
        margin 20px
        padding 60px 40px 20px 40px
        background #f8f8f8
        box-shadow 3px 3px 3px #f5f5f5 inset
        .list
            width: 960px
            margin: 0 auto
            font-size: 0
            .title
                width: 100%
                height: 40px
                line-height: 50px
                padding-left: 15px
                font-size: 14px
            li
                display: inline-block
                width: 15%
                margin: 1.66%
                background: #ffffff
                text-align: center
                font-size: 12px
                span
                    display: block
                    padding: 5px 0
                    img
                        width: 50%
                .name
                    padding: 5px 0
</style>



// WEBPACK FOOTER //
// src/components/card/card.vue